import React from 'react';
import { TrialInputProps } from '~/common/types';
import { Input } from '~/common/components/Input';
import { validateEmail } from '~/common/util/customValidation';
import { Field } from 'formik';
import styles from '../Grid.module.css';
import { trackBlur } from '~/common/util/trackBlur';
import { MODIFIER_TYPE, TRIAL_TYPES } from '~/common/consts';
import { useAppStore } from '~/common/store/appStore';
import { useShallow } from 'zustand/react/shallow';

export const EmailOnlyInput = (props: TrialInputProps) => {
  const {
    formikTouched,
    formikErrors,
    inputs,
    showHint,
    trackErrorBlur,
    validateBusinessEmail,
    existingAccount,
    userEmail,
    existingEmailError,
    mistypedEmailError,
  } = props;

  const { email } = inputs;

  const { trialType, modifier, emailPlaceholder } = useAppStore(
    useShallow((state) => ({
      trialType: state.trialType,
      modifier: state.modifier,
      emailPlaceholder: state.emailPlaceholder,
    }))
  );

  const hero = modifier === MODIFIER_TYPE.HERO;

  const ABTestPlaceholderString = () => {
    return trialType === TRIAL_TYPES.PREMIUM || trialType === TRIAL_TYPES.TEAMS
      ? 'Enter your email'
      : email.placeHolder;
  };

  return (
    <div className={`${styles.inputGrid} ${styles.trial} ${hero ? styles.hero : ''}`}>
      {!userEmail ? (
        <Field
          name={email.id}
          type={'email'}
          error={formikErrors[email.id] && formikTouched[email.id]}
          errormessage={
            mistypedEmailError
              ? `${email.placeHolder} ${mistypedEmailError}`
              : existingAccount
                ? existingEmailError
                : email.error
          }
          showHint={showHint}
          hintmessage={hero && emailPlaceholder ? emailPlaceholder : email.placeHolder}
          validate={validateEmail}
          as={Input}
          label={hero ? null : email.label}
          maxLength={128}
          onFocus={() => {
            trackBlur(email.id);
          }}
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
            trialType !== TRIAL_TYPES.PREMIUM && trialType !== TRIAL_TYPES.FAMILIES
              ? validateBusinessEmail(event.target.value)
              : validateEmail(event.target.value);
            trackErrorBlur(email.id, validateEmail, event.target.value);
          }}
          autoFocus={hero ? false : true}
          placeHolder={hero ? (emailPlaceholder || ABTestPlaceholderString()) : null}
        />
      ) : (
        <div></div>
      )}
    </div>
  );
};
